import { axiosInstance } from "../../../hoc/Axios/Axios";

export const createGlossary = data => () => axiosInstance.post("glossaries", data).then(() => null).catch(() => null)
